import { kmsClient } from 'api/apollo';
import { useMutation } from '@apollo/react-hooks';
import { UPLOAD_IMAGES } from './uploadImages.mutation';
import { UploadImages, UploadImagesVariables } from './__generated__/UploadImages';

export const useUploadImages = () => {
  return useMutation<UploadImages, UploadImagesVariables>(UPLOAD_IMAGES, {
    client: kmsClient
  });
};
